<!-- eslint-disable prefer-destructuring -->
<template>
  <v-card
    class="mbSection simplified-section"
  >
    <v-card-title
      style="display: flex; justify-content: space-between;"
    >
      <div
        style="width: 40%; font-size: 14px; overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;"
      >
        {{ massBalanceName }}
      </div>
      <div
        style="width: 60%; font-size: 14px;"
        class="mbSection__header__date"
      >
        {{ moment(measureDetails.previousWODate).format('YYYY-MM-DD') }} - {{ moment(measureDetails.currentWODate).format('YYYY-MM-DD') }}
      </div>
    </v-card-title>

    <v-tabs
      v-model="tab"
      :value="tab"
      grow
    >
      <v-tab
        v-for="unit in units"
        :key="unit"
        :value="unit"
      >
        {{ flowmeterTabLabel(unit) }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item
        v-for="unit in units"
        :key="unit"
      >
        <div
          class="mbSection__analyses"
        >
          <div class="mbSection__analyses__header mbSection__analyses__header__inActive">
            {{ $t('massBalance.sectionWO.parameters') }}
          </div>
          <div class="mbSection__analyses__body">
            <div class="mbSection__analyses__body__lign">
              <div
                style="width: 20%;"
                class="mbSection__analyses__header__inActive"
              />
              <div
                style="width: 20%;"
                class="mbSection__analyses__header__inActive"
              >
                {{ $t('massBalance.simplified.daily') }}
              </div>
              <div
                style="width: 20%;"
                class="mbSection__analyses__header__inActive"
              >
                {{ $t('massBalance.simplified.weekly') }}
              </div>
              <div
                style="width: 20%;"
                class="mbSection__analyses__header__inActive"
              >
                {{ $t('massBalance.simplified.monthly') }}
              </div>
              <div
                style="width: 20%; padding-right: 10px;"
                class="mbSection__analyses__header__inActive"
              >
                {{ $t('massBalance.simplified.total') }}
              </div>
            </div>
          </div>
          <div class="mbSection__analyses__content">
            <!-- Total days -->
            <div class="mbSection__analyses__body">
              <div class="mbSection__analyses__body__lign">
                <div style="width: 50%;">
                  {{ $t('massBalance.sectionWO.totalDays') }}
                </div>
                <div style="width: 50%;">
                  {{ measureDetails.totalDays }}
                </div>
              </div>
            </div>
            <!-- Compteurs d'appoint -->
            <div class="mbSection__analyses__body">
              <div class="mbSection__analyses__body__lign">
                <div style="width: 20%;">
                  {{ flowmeterName }}
                </div>
                <div style="width: 20%;">
                  {{ totalFlowMetersValue[unit].daily }}
                </div>
                <div style="width: 20%;">
                  {{ totalFlowMetersValue[unit].weekly }}
                </div>
                <div style="width: 20%;">
                  {{ totalFlowMetersValue[unit].monthly }}
                </div>
                <div style="width: 20%;">
                  {{ totalFlowMetersValue[unit].total }}
                </div>
              </div>
            </div>
            <!-- Others -->
            <div
              v-if="displayMeters"
            >
              <div
                v-for="(flowmeter, idx) in flowMetersValuesBySpan"
                :key="idx"
                class="mbSection__analyses__body"
              >
                <div
                  class="mbSection__analyses__body__lign"
                >
                  <div style="width: 20%;">
                    {{ flowmeter.flowMeterName || '' }}
                  </div>
                  <div style="width: 20%;">
                    {{ flowmeter.values[unit].daily }}
                  </div>
                  <div style="width: 20%;">
                    {{ flowmeter.values[unit].weekly }}
                  </div>
                  <div style="width: 20%;">
                    {{ flowmeter.values[unit].monthly }}
                  </div>
                  <div style="width: 20%;">
                    {{ flowmeter.values[unit].total }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-tab-item>
    </v-tabs-items>

    <v-tabs
      v-model="productTab"
      grow
    >
      <v-tab
        v-for="selectedTab in productTabs"
        :key="selectedTab"
      >
        {{ $t(`massBalance.simplified.${selectedTab}`) }}
      </v-tab>
    </v-tabs>
    <v-tabs-items
      v-model="productTab"
    >
      <v-tab-item
        v-for="productActiveTab in productTabs"
        :key="productActiveTab"
      >
        <div
          v-if="productActiveTab === 'concentration'"
        >
          <div v-if="showProductSection">
            <div class="mbSection__analyses__body">
              <div class="mbSection__analyses__body__lign">
                <div
                  style="width: 25%; padding-left: 10px;"
                  class="mbSection__analyses__header__inActive"
                >
                  {{ $t('massBalance.sectionWO.products') }}
                </div>
                <div
                  style="width: 25%;"
                  class="mbSection__analyses__header__inActive"
                >
                  {{ $t('massBalance.sectionWO.quantities') }}
                </div>
                <div
                  style="width: 25%;"
                  class="mbSection__analyses__header__inActive"
                >
                  {{ $t('massBalance.sectionWO.realPPM') }}
                </div>
                <div
                  style="width: 25%; padding-right: 10px;"
                  class="mbSection__analyses__header__inActive"
                >
                  {{ $t('massBalance.sectionWO.targetPPM') }}
                </div>
              </div>
            </div>
            <div class="mbSection__analyses__content">
              <div
                v-for="(product, idx) in measureDetails.productParameters"
                :key="idx"
                class="mbSection__analyses__body"
              >
                <div
                  class="mbSection__analyses__body__lign"
                >
                  <div style="width: 25%;">
                    {{ product.productName }}
                  </div>
                  <div style="width: 25%;">
                    {{ product.productConsumptionInReportUnit }} {{ product.reportUnit }}
                  </div>
                  <div style="width: 25%;">
                    {{ getRealPPm(idx, product) }}
                  </div>
                  <div style="width: 25%;">
                    {{ product.targetPPM }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-else
            class="mbSection__analyses__content"
          >
            {{ $t('massBalance.sectionWO.noData') }}
          </div>
        </div>
        <div v-if="productActiveTab === 'quantity'">
          <div v-if="showProductSection">
            <div class="mbSection__analyses__body">
              <div class="mbSection__analyses__body__lign">
                <div
                  style="width: 20%; padding-left: 10px;"
                  class="mbSection__analyses__header__inActive"
                >
                  {{ $t('massBalance.sectionWO.products') }}
                </div>
                <div
                  style="width: 20%;"
                  class="mbSection__analyses__header__inActive"
                >
                  {{ $t('massBalance.simplified.daily') }}
                </div>
                <div
                  style="width: 20%;"
                  class="mbSection__analyses__header__inActive"
                >
                  {{ $t('massBalance.simplified.weekly') }}
                </div>
                <div
                  style="width: 20%;"
                  class="mbSection__analyses__header__inActive"
                >
                  {{ $t('massBalance.simplified.monthly') }}
                </div>
                <div
                  style="width: 20%; padding-right: 10px;"
                  class="mbSection__analyses__header__inActive"
                >
                  {{ $t('massBalance.simplified.total') }}
                </div>
              </div>
            </div>
            <div class="mbSection__analyses__content">
              <div
                v-for="(product, idx) in productsArray"
                :key="idx"
                class="mbSection__analyses__body"
              >
                <div
                  class="mbSection__analyses__body__lign"
                >
                  <div style="width: 20%;">
                    {{ product.productName }}
                  </div>
                  <div style="width: 20%;">
                    {{ product.daily }}
                  </div>
                  <div style="width: 20%;">
                    {{ product.weekly }}
                  </div>
                  <div style="width: 20%;">
                    {{ product.monthly }}
                  </div>
                  <div style="width: 20%;">
                    {{ product.total }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-else
            class="mbSection__analyses__content"
          >
            {{ $t('massBalance.sectionWO.noData') }}
          </div>
        </div>
      </v-tab-item>
    </v-tabs-items>
    <!-- Show on PDF -->
    <div
      :class="`mbSection__products__body__showOnPDF ${!measureDetails.showMassBalance ?
        'mbSection__products__body__showOnPDF__inActivBar' : 'mbSection__products__body__showOnPDF__activBar'}`"
    >
      <v-switch
        v-model="measureDetails.showOnReport"
        :color="colorActiveOrInactive"
        @change="toggleshowPdfInMeasureMassBalance"
      />
      <div> {{ $t('massBalance.sectionWO.showAllOnPDF') }} </div>
    </div>
  </v-card>
</template>
<script>
import { mapGetters } from 'vuex';
import { INDICATOR_TYPES } from '@/aquassist-shared/constants/massBalance';
import isEmpty from 'lodash/isEmpty';

const { TYPE_BLOWDOWN, TYPE_MAKE_UP, TYPE_FEED } = require('@/aquassist-shared/constants/types/flowMeters');


export default {
    name: 'Simplified',
    props: {
        measureDetails: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            tab: 'mass',
            massBalanceConfig: {},
            flowmeterName: '',
            displayMeters: false,
            massBalanceName: '',
            units: ['mass', 'volume'],
            productTabs: ['quantity', 'concentration'],
            productTab: 'quantity',
            selectedUnit: 'mass',
            productsArray: [],
        };
    },
    computed: {
        ...mapGetters([
            'workOrder',
        ]),
        flowMetersOnly() {
            return this.massBalanceConfig.indicatorType === INDICATOR_TYPES.flowMetersOnly;
        },
        flowMeterType() {
            // for simplified MB, flowMeterType is always has just one flowMeterType type
            return !isEmpty(this.massBalanceConfig) ? this?.massBalanceConfig?.flowmeters[0].type.toLowerCase() : '';
        },
        flowMetersValuesBySpan() {
            const flowMetersValuesBySpan = [];
            const flowMeterType = this.flowMeterType === TYPE_FEED.toLowerCase() ? 'feedwater' : this.flowMeterType;
            if (!isEmpty(this.measureDetails.additionalInfo[flowMeterType])) {
                const { totalDays } = this.measureDetails;
                let flowMeterCounter = 0;
                // we always have just one flowmeter type so massBalanceConfig.flowmeters[0].config is always an array with one element
                this.massBalanceConfig.flowmeters[0].config.forEach(config => {
                    config.flowmeterIds.forEach(flowmeter => {
                        flowMetersValuesBySpan.push({
                            flowMeterName: flowmeter?.name,
                            values: {
                                mass: {
                                    daily: this.calculateTotalFlowMetersValue(this.measureDetails?.additionalInfo[flowMeterType][flowMeterCounter]?.massValue, totalDays, 'daily'),
                                    weekly: this.calculateTotalFlowMetersValue(this.measureDetails?.additionalInfo[flowMeterType][flowMeterCounter]?.massValue, totalDays, 'weekly'),
                                    monthly: this.calculateTotalFlowMetersValue(this.measureDetails?.additionalInfo[flowMeterType][flowMeterCounter]?.massValue, totalDays, 'monthly'),
                                    total: this.$utils.formatFloat(this.measureDetails?.additionalInfo[flowMeterType][flowMeterCounter]?.massValue),
                                },
                                volume: {
                                    daily: this.calculateTotalFlowMetersValue(this.measureDetails?.additionalInfo[flowMeterType][flowMeterCounter]?.volumeValue, totalDays, 'daily'),
                                    weekly: this.calculateTotalFlowMetersValue(this.measureDetails?.additionalInfo[flowMeterType][flowMeterCounter]?.volumeValue / (totalDays / 7), totalDays, 'weekly'),
                                    monthly: this.calculateTotalFlowMetersValue(this.measureDetails?.additionalInfo[flowMeterType][flowMeterCounter]?.volumeValue / (totalDays / 30), totalDays, 'monthly'),
                                    total: this.$utils.formatFloat(this.measureDetails?.additionalInfo[flowMeterType][flowMeterCounter]?.volumeValue),
                                },
                            },
                        });
                        flowMeterCounter += 1;
                    });
                });
            }
            return flowMetersValuesBySpan;
        },
        totalFlowMetersValue() {
            let type = '';
            if (!this.flowMeterType) return { mass: '', volume: '' };
            switch (this.flowMeterType.toUpperCase()) {
                case TYPE_BLOWDOWN:
                    type = 'BD';
                    break;
                case TYPE_MAKE_UP:
                    type = 'MU';
                    break;
                case TYPE_FEED:
                    type = 'FW';
                    break;
                default:
                    break;
            }

            const [massValue, volumeValue] = this.measureDetails[type];
            const massTotal = typeof massValue === 'number' && Number.isFinite(massValue) ? massValue.toFixed(2) : null;
            const volumeTotal = typeof volumeValue === 'number' && Number.isFinite(volumeValue) ? volumeValue.toFixed(2) : null;

            return {
                mass: {
                    total: this.$utils.formatFloat(massTotal),
                    daily: massTotal !== null ? this.$utils.formatFloat((massTotal / this.measureDetails.totalDays).toFixed(2)) : '',
                    weekly: massTotal !== null ? this.$utils.formatFloat((massTotal / (this.measureDetails.totalDays / 7)).toFixed(2)) : '',
                    monthly: massTotal !== null ? this.$utils.formatFloat((massTotal / (this.measureDetails.totalDays / 30)).toFixed(2)) : '',
                },
                volume: {
                    total: this.$utils.formatFloat(volumeTotal),
                    daily: volumeTotal !== null ? this.$utils.formatFloat((volumeTotal / this.measureDetails.totalDays).toFixed(2)) : '',
                    weekly: volumeTotal !== null ? this.$utils.formatFloat((volumeTotal / (this.measureDetails.totalDays / 7)).toFixed(2)) : '',
                    monthly: volumeTotal !== null ? this.$utils.formatFloat((volumeTotal / (this.measureDetails.totalDays / 30)).toFixed(2)) : '',
                },
            };
        },
        showProductSection() {
            const [flowMetersOnly] = INDICATOR_TYPES;
            return this.massBalanceConfig.indicatorType !== flowMetersOnly;
        },

        colorActiveOrInactive() {
            return this.measureDetails.showMassBalance ? 'primary' : '#DCDCDC';
        },
    },
    async created() {
        const { data: massBalanceConfig } = await this.$rq.getOneMassBalanceConfig(
            this.workOrder.site.ref, this.measureDetails.configId, { params: { populateFlowMeters: true } },
        );
        this.massBalanceConfig = massBalanceConfig;
        this.displayMeters = this.massBalanceConfig.flowmeterGeneralProps.displayMeters;
        this.flowmeterName = this.massBalanceConfig?.flowmeterGeneralProps?.name || '';
        this.massBalanceName = massBalanceConfig?.name || '';
        this.productsArray = this.prepareProductsArray();
    },
    methods: {
        prepareProductsArray() {
            const productsArray = [];
            this.measureDetails.productParameters.forEach(product => {
                if (product.productConsumptionInReportUnit === null && product.productConsumptionInReportUnit === undefined) {
                    productsArray.push({
                        productName: product.productName,
                        total: null,
                        daily: null,
                        weekly: null,
                        monthly: null,
                    });
                } else {
                    productsArray.push({
                        productName: product.productName,
                        total: `${this.$utils.formatFloat(product.productConsumptionInReportUnit)} ${product.reportUnit}`,
                        daily: this.$utils.formatFloat(product.productConsumptionInReportUnit / this.measureDetails.totalDays),
                        weekly: this.$utils.formatFloat(product.productConsumptionInReportUnit / (this.measureDetails.totalDays / 7)),
                        monthly: this.$utils.formatFloat(product.productConsumptionInReportUnit / (this.measureDetails.totalDays / 30)),
                    });
                }
            });
            return productsArray;
        },
        getRealPPm(idx, product) {
            if (!isEmpty(this.massBalanceConfig)
            && !this.massBalanceConfig.products[idx].activeConcentration
             && product.productConcentration.length) {
                return product.productConcentration[0];
            }
            return product.productConcentration[1];
        },
        calculateTotalFlowMetersValue(value, totalDays, span) {
            if (value === null || value === undefined) return '';
            if (totalDays === null || totalDays === undefined || totalDays === 0) return this.$utils.formatFloat(value);
            if (span === 'daily') {
                return this.$utils.formatFloat(value / totalDays);
            }
            if (span === 'weekly') {
                return this.$utils.formatFloat(value / (totalDays / 7));
            }
            if (span === 'monthly') {
                return this.$utils.formatFloat(value / (totalDays / 30));
            }
            if (span === 'total') {
                return value;
            }
            return this.$utils.formatFloat(this.$utils.formatFloat(value)).toLocaleString();
        },
        flowmeterTabLabel(unit) {
            const { massUnit, volumeUnit } = this.massBalanceConfig?.reportUnit || { massUnit: '', volumeUnit: '' };
            return `${this.$t(`massBalance.modalStep.${unit}`)} (${unit === 'mass' ? massUnit : volumeUnit})`;
        },
        toggleshowPdfInMeasureMassBalance() {
            this.$emit('change', this.measureDetails.id, this.measureDetails.showOnReport);
        },

    },
};
</script>
<style lang="scss" scoped>
@import "@/assets/styles/components/massBalanceWorkOrder.scss";

.simplified-section {
    min-height: 545px;
    flex:1;
    .v-item-group {
        max-height: 200px;
        overflow-y: auto;
        overflow-x: hidden;
    }
}
</style>
